import { watch } from 'vue';
import { i18n } from '@/i18n';

// Runs `callback` whenever the language changes. Use it for data whose text comes from the API (names of categories
// and subcategories), which the server sends in the language of the request: it has to be fetched again.
export function useOnLocaleChange(callback) {
    watch(() => i18n.global.locale.value, () => callback());
}
